import type {CopNetworkSopNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/sop/CopNetwork';
import type {MaterialsNetworkSopNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/sop/MaterialsNetwork';
import type {GeoObjNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/obj/Geo';
import type {EventsNetworkSopNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/sop/EventsNetwork';
import type {PerspectiveCameraObjNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/obj/PerspectiveCamera';
import type {RootManagerNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/manager/Root';
import type {ExampleData, DataCallbackOptions} from '../../Common';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();

	function create_geo1(parentNode: RootManagerNode) {
		var geo1 = parentNode.createNode('geo');
		geo1.setName('geo1');
		function create_COP(geo1: GeoObjNode) {
			var COP = geo1.createNode('copNetwork');
			COP.setName('COP');
			function create_image1(COP: CopNetworkSopNode) {
				var image1 = COP.createNode('image');
				image1.setName('image1');
				image1.uiData.setComment(
					'Each of those node loads a single texture.\n\nWhen selecting a node, you can use the preset dropdown menu to fetch another matcap texture.'
				);
				image1.uiData.setPosition(-350, 0);
				image1.p.url.set('https://makio135.com/matcaps/512/346088_6ABED7_56A0C5_4E91B8-512px.png');
				image1.p.tanisotropy.set(true);
				image1.p.useRendererMaxAnisotropy.set(true);
				image1.params.postCreateSpareParams();
				image1.params.runOnSceneLoadHooks();
				return image1;
			}
			function create_image2(COP: CopNetworkSopNode) {
				var image2 = COP.createNode('image');
				image2.setName('image2');
				image2.uiData.setPosition(-350, 250);
				image2.p.url.set('https://makio135.com/matcaps/512/2D2D2F_C6C2C5_727176_94949B-512px.png');
				image2.p.tanisotropy.set(true);
				image2.p.useRendererMaxAnisotropy.set(true);
				image2.params.postCreateSpareParams();
				image2.params.runOnSceneLoadHooks();
				return image2;
			}
			function create_image3(COP: CopNetworkSopNode) {
				var image3 = COP.createNode('image');
				image3.setName('image3');
				image3.uiData.setPosition(-350, 400);
				image3.p.url.set('https://makio135.com/matcaps/512/593E2C_E5D8A9_BC9F79_9F8A68-512px.png');
				image3.p.tanisotropy.set(true);
				image3.p.useRendererMaxAnisotropy.set(true);
				image3.params.postCreateSpareParams();
				image3.params.runOnSceneLoadHooks();
				return image3;
			}
			function create_image4(COP: CopNetworkSopNode) {
				var image4 = COP.createNode('image');
				image4.setName('image4');
				image4.uiData.setPosition(-350, 550);
				image4.p.url.set('https://makio135.com/matcaps/512/BC5B43_95170B_EEAC92_DB8C7C-512px.png');
				image4.p.tanisotropy.set(true);
				image4.p.useRendererMaxAnisotropy.set(true);
				image4.params.postCreateSpareParams();
				image4.params.runOnSceneLoadHooks();
				return image4;
			}
			function create_image5(COP: CopNetworkSopNode) {
				var image5 = COP.createNode('image');
				image5.setName('image5');
				image5.uiData.setPosition(-350, 700);
				image5.p.url.set('https://makio135.com/matcaps/512/9B9994_E1E0DB_474643_544C4C-512px.png');
				image5.p.tanisotropy.set(true);
				image5.p.useRendererMaxAnisotropy.set(true);
				image5.params.postCreateSpareParams();
				image5.params.runOnSceneLoadHooks();
				return image5;
			}
			create_image1(COP);
			create_image2(COP);
			create_image3(COP);
			create_image4(COP);
			create_image5(COP);
			COP.uiData.setComment('enter into this node to see how the matcap textures are loaded');
			COP.uiData.setPosition(-350, 400);
			COP.params.postCreateSpareParams();
			COP.params.runOnSceneLoadHooks();
			return COP;
		}
		function create_MAT(geo1: GeoObjNode) {
			var MAT = geo1.createNode('materialsNetwork');
			MAT.setName('MAT');
			function create_meshMatcap1(MAT: MaterialsNetworkSopNode) {
				var meshMatcap1 = MAT.createNode('meshMatcap');
				meshMatcap1.setName('meshMatcap1');
				meshMatcap1.uiData.setPosition(0, -50);
				meshMatcap1.p.useMatcapMap.set(true);
				meshMatcap1.p.matcapMap.set('../../COP/image1');
				meshMatcap1.params.postCreateSpareParams();
				meshMatcap1.params.runOnSceneLoadHooks();
				return meshMatcap1;
			}
			function create_meshMatcap2(MAT: MaterialsNetworkSopNode) {
				var meshMatcap2 = MAT.createNode('meshMatcap');
				meshMatcap2.setName('meshMatcap2');
				meshMatcap2.uiData.setPosition(0, 100);
				meshMatcap2.p.useMatcapMap.set(true);
				meshMatcap2.p.matcapMap.set('../../COP/image2');
				meshMatcap2.params.postCreateSpareParams();
				meshMatcap2.params.runOnSceneLoadHooks();
				return meshMatcap2;
			}
			function create_meshMatcap3(MAT: MaterialsNetworkSopNode) {
				var meshMatcap3 = MAT.createNode('meshMatcap');
				meshMatcap3.setName('meshMatcap3');
				meshMatcap3.uiData.setPosition(0, 250);
				meshMatcap3.p.useMatcapMap.set(true);
				meshMatcap3.p.matcapMap.set('../../COP/image3');
				meshMatcap3.params.postCreateSpareParams();
				meshMatcap3.params.runOnSceneLoadHooks();
				return meshMatcap3;
			}
			function create_meshMatcap4(MAT: MaterialsNetworkSopNode) {
				var meshMatcap4 = MAT.createNode('meshMatcap');
				meshMatcap4.setName('meshMatcap4');
				meshMatcap4.uiData.setPosition(0, 400);
				meshMatcap4.p.useMatcapMap.set(true);
				meshMatcap4.p.matcapMap.set('../../COP/image4');
				meshMatcap4.params.postCreateSpareParams();
				meshMatcap4.params.runOnSceneLoadHooks();
				return meshMatcap4;
			}
			function create_meshMatcap5(MAT: MaterialsNetworkSopNode) {
				var meshMatcap5 = MAT.createNode('meshMatcap');
				meshMatcap5.setName('meshMatcap5');
				meshMatcap5.uiData.setPosition(0, 550);
				meshMatcap5.p.useMatcapMap.set(true);
				meshMatcap5.p.matcapMap.set('../../COP/image5');
				meshMatcap5.params.postCreateSpareParams();
				meshMatcap5.params.runOnSceneLoadHooks();
				return meshMatcap5;
			}
			create_meshMatcap1(MAT);
			create_meshMatcap2(MAT);
			create_meshMatcap3(MAT);
			create_meshMatcap4(MAT);
			create_meshMatcap5(MAT);
			MAT.uiData.setComment('Enter this node to see how the materials are set up.');
			MAT.uiData.setPosition(-350, 250);
			MAT.params.postCreateSpareParams();
			MAT.params.runOnSceneLoadHooks();
			return MAT;
		}
		function create_fileOBJ1(geo1: GeoObjNode) {
			var fileOBJ1 = geo1.createNode('fileOBJ');
			fileOBJ1.setName('fileOBJ1');
			fileOBJ1.uiData.setPosition(450, -400);
			fileOBJ1.p.url.set(
				'https://raw.githubusercontent.com/polygonjs/polygonjs-assets/master/models/resources/3dscanstore.com/BaseMeshes/OBJ/Male-Average-Head.obj'
			);
			fileOBJ1.params.postCreateSpareParams();
			fileOBJ1.params.runOnSceneLoadHooks();
			return fileOBJ1;
		}
		function create_hierarchy1(geo1: GeoObjNode) {
			var hierarchy1 = geo1.createNode('hierarchy');
			hierarchy1.setName('hierarchy1');
			hierarchy1.uiData.setPosition(450, -250);
			hierarchy1.p.mode.set(1);
			hierarchy1.params.postCreateSpareParams();
			hierarchy1.params.runOnSceneLoadHooks();
			return hierarchy1;
		}
		function create_material1(geo1: GeoObjNode) {
			var material1 = geo1.createNode('material');
			material1.setName('material1');
			material1.uiData.setComment('the sop/material nodes assign a material to the input object.');
			material1.uiData.setPosition(50, 450);
			material1.p.material.set('../MAT/meshMatcap1');
			material1.params.postCreateSpareParams();
			material1.params.runOnSceneLoadHooks();
			return material1;
		}
		function create_material2(geo1: GeoObjNode) {
			var material2 = geo1.createNode('material');
			material2.setName('material2');
			material2.uiData.setPosition(250, 450);
			material2.p.material.set('../MAT/meshMatcap2');
			material2.params.postCreateSpareParams();
			material2.params.runOnSceneLoadHooks();
			return material2;
		}
		function create_material3(geo1: GeoObjNode) {
			var material3 = geo1.createNode('material');
			material3.setName('material3');
			material3.uiData.setPosition(450, 450);
			material3.p.material.set('../MAT/meshMatcap3');
			material3.params.postCreateSpareParams();
			material3.params.runOnSceneLoadHooks();
			return material3;
		}
		function create_material4(geo1: GeoObjNode) {
			var material4 = geo1.createNode('material');
			material4.setName('material4');
			material4.uiData.setPosition(650, 450);
			material4.p.material.set('../MAT/meshMatcap4');
			material4.params.postCreateSpareParams();
			material4.params.runOnSceneLoadHooks();
			return material4;
		}
		function create_material5(geo1: GeoObjNode) {
			var material5 = geo1.createNode('material');
			material5.setName('material5');
			material5.uiData.setPosition(850, 450);
			material5.p.material.set('../MAT/meshMatcap5');
			material5.params.postCreateSpareParams();
			material5.params.runOnSceneLoadHooks();
			return material5;
		}
		function create_merge1(geo1: GeoObjNode) {
			var merge1 = geo1.createNode('merge');
			merge1.setName('merge1');
			merge1.uiData.setComment(
				'Here we are merging 5 copies of the same object, which is imported from the file node at  the top.\n\nThen using the material nodes, each object is assigned a different material. '
			);
			merge1.uiData.setPosition(450, 800);
			merge1.flags.display.set(true);
			merge1.p.inputsCount.set(5);
			merge1.io.inputs.setCount(1, 5);
			merge1.params.postCreateSpareParams();
			merge1.params.runOnSceneLoadHooks();
			return merge1;
		}
		function create_objectProperties1(geo1: GeoObjNode) {
			var objectProperties1 = geo1.createNode('objectProperties');
			objectProperties1.setName('objectProperties1');
			objectProperties1.uiData.setPosition(450, -50);
			objectProperties1.p.tcastShadow.set(true);
			objectProperties1.p.treceiveShadow.set(true);
			objectProperties1.params.postCreateSpareParams();
			objectProperties1.params.runOnSceneLoadHooks();
			return objectProperties1;
		}
		function create_transform1(geo1: GeoObjNode) {
			var transform1 = geo1.createNode('transform');
			transform1.setName('transform1');
			transform1.uiData.setPosition(450, -150);
			transform1.params.postCreateSpareParams();
			transform1.params.runOnSceneLoadHooks();
			return transform1;
		}
		function create_transform2(geo1: GeoObjNode) {
			var transform2 = geo1.createNode('transform');
			transform2.setName('transform2');
			transform2.uiData.setPosition(50, 200);
			transform2.p.t.set([-1.5, 0, 0]);
			transform2.params.postCreateSpareParams();
			transform2.params.runOnSceneLoadHooks();
			return transform2;
		}
		function create_transform3(geo1: GeoObjNode) {
			var transform3 = geo1.createNode('transform');
			transform3.setName('transform3');
			transform3.uiData.setPosition(250, 200);
			transform3.p.t.set([-0.75, 0, 0]);
			transform3.params.postCreateSpareParams();
			transform3.params.runOnSceneLoadHooks();
			return transform3;
		}
		function create_transform4(geo1: GeoObjNode) {
			var transform4 = geo1.createNode('transform');
			transform4.setName('transform4');
			transform4.uiData.setPosition(450, 200);
			transform4.params.postCreateSpareParams();
			transform4.params.runOnSceneLoadHooks();
			return transform4;
		}
		function create_transform5(geo1: GeoObjNode) {
			var transform5 = geo1.createNode('transform');
			transform5.setName('transform5');
			transform5.uiData.setPosition(650, 200);
			transform5.p.t.set([0.75, 0, 0]);
			transform5.params.postCreateSpareParams();
			transform5.params.runOnSceneLoadHooks();
			return transform5;
		}
		function create_transform6(geo1: GeoObjNode) {
			var transform6 = geo1.createNode('transform');
			transform6.setName('transform6');
			transform6.uiData.setPosition(850, 200);
			transform6.p.t.set([1.5, 0, 0]);
			transform6.params.postCreateSpareParams();
			transform6.params.runOnSceneLoadHooks();
			return transform6;
		}
		create_COP(geo1);
		create_MAT(geo1);
		var fileOBJ1 = create_fileOBJ1(geo1);
		var hierarchy1 = create_hierarchy1(geo1);
		var material1 = create_material1(geo1);
		var material2 = create_material2(geo1);
		var material3 = create_material3(geo1);
		var material4 = create_material4(geo1);
		var material5 = create_material5(geo1);
		var merge1 = create_merge1(geo1);
		var objectProperties1 = create_objectProperties1(geo1);
		var transform1 = create_transform1(geo1);
		var transform2 = create_transform2(geo1);
		var transform3 = create_transform3(geo1);
		var transform4 = create_transform4(geo1);
		var transform5 = create_transform5(geo1);
		var transform6 = create_transform6(geo1);
		hierarchy1.setInput(0, fileOBJ1);
		material1.setInput(0, transform2);
		material2.setInput(0, transform3);
		material3.setInput(0, transform4);
		material4.setInput(0, transform5);
		material5.setInput(0, transform6);
		merge1.setInput(0, material1);
		merge1.setInput(1, material2);
		merge1.setInput(2, material3);
		merge1.setInput(3, material4);
		merge1.setInput(4, material5);
		objectProperties1.setInput(0, transform1);
		transform1.setInput(0, hierarchy1);
		transform2.setInput(0, objectProperties1);
		transform3.setInput(0, objectProperties1);
		transform4.setInput(0, objectProperties1);
		transform5.setInput(0, objectProperties1);
		transform6.setInput(0, objectProperties1);
		geo1.uiData.setPosition(-50, -150);
		geo1.flags.display.set(true);
		geo1.params.postCreateSpareParams();
		geo1.params.runOnSceneLoadHooks();
		return geo1;
	}
	function create_perspectiveCamera1(parentNode: RootManagerNode) {
		var perspectiveCamera1 = parentNode.createNode('perspectiveCamera');
		perspectiveCamera1.setName('perspectiveCamera1');
		function create_events1(perspectiveCamera1: PerspectiveCameraObjNode) {
			var events1 = perspectiveCamera1.createNode('eventsNetwork');
			events1.setName('events1');
			function create_cameraOrbitControls1(events1: EventsNetworkSopNode) {
				var cameraOrbitControls1 = events1.createNode('cameraOrbitControls');
				cameraOrbitControls1.setName('cameraOrbitControls1');
				cameraOrbitControls1.uiData.setPosition(150, 50);
				cameraOrbitControls1.p.target.set([-0.0019975972039125304, 0.5017383128930296, -0.001698771209347175]);
				cameraOrbitControls1.params.postCreateSpareParams();
				cameraOrbitControls1.params.runOnSceneLoadHooks();
				return cameraOrbitControls1;
			}
			create_cameraOrbitControls1(events1);
			events1.uiData.setPosition(-200, 50);
			events1.params.postCreateSpareParams();
			events1.params.runOnSceneLoadHooks();
			return events1;
		}
		create_events1(perspectiveCamera1);
		perspectiveCamera1.uiData.setPosition(-250, 100);
		perspectiveCamera1.flags.display.set(true);
		perspectiveCamera1.p.t.set([1.6847874698329743, 0.8811292707702931, 1.872359309424121]);
		perspectiveCamera1.p.r.set([-11.444488908832222, 41.417936387103744, 7.627996414970768]);
		perspectiveCamera1.p.s.set([1, 0.9999999999999997, 1]);
		perspectiveCamera1.p.controls.set('./events1/cameraOrbitControls1');
		perspectiveCamera1.params.postCreateSpareParams();
		perspectiveCamera1.params.runOnSceneLoadHooks();
		return perspectiveCamera1;
	}
	function create_hemisphereLight1(parentNode: RootManagerNode) {
		var hemisphereLight1 = parentNode.createNode('hemisphereLight');
		hemisphereLight1.setName('hemisphereLight1');
		hemisphereLight1.uiData.setPosition(150, 100);
		hemisphereLight1.flags.display.set(true);
		hemisphereLight1.params.postCreateSpareParams();
		hemisphereLight1.params.runOnSceneLoadHooks();
		return hemisphereLight1;
	}
	var geo1 = create_geo1(root);
	var perspectiveCamera1 = create_perspectiveCamera1(root);
	create_hemisphereLight1(root);
	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [geo1.nodesByType('material')[0]],
		autoLayout: false,
	};
}
// export const matMeshMatcap = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/mat/meshMatcap`,
// 		createData,
// 		relatedNodes: [MeshMatcapMatNode],
// 	}),
// ];
